import React from 'react';
import {Modal} from "../common/Modal";
import {ConditionalRenderer} from "../common/ConditionalRenderer";
import {PillButton} from "../common/PillButton";
import {OverlayLoadingIndicator} from "../common/OverlayLoadingIndicator";

export let CommonCustomerForm = function (props) {
    return (
        <Modal
            headerText={props.headerText}
            onClickCloseOption={props.cancel}
            boxClass="common-customer-modal-box"
        >
            <ConditionalRenderer if={props.formEngine.renderableData.showOverlayLoadingIndicator} renderer={() => (
                <OverlayLoadingIndicator/>
            )}/>
            <div className="common-form common-customer-form">
                <div className="common-form-body">
                    <ConditionalRenderer if={props.showingProposedValues} renderer={() => (
                        <div className="common-form-body-row proposed-data-explainer">
                            Below proposed values are from the FP invoice company and contact.
                        </div>
                    )}/>

                    <div className="common-form-body-row">
                        <div className={props.formEngine.getFormFieldClasses("common-form-field", "name")}>
                            <div className="common-form-field-label">
                                Name
                            </div>
                            <div className="common-form-field-input-container">
                                <input
                                    id="customerName"
                                    type="text"
                                    className="common-form-input"
                                    value={props.formEngine.renderableData.name}
                                    onChange={(event) => props.formEngine.handleTextFieldChange("name", event)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="common-form-body-row">
                        <div className={props.formEngine.getFormFieldClasses("common-form-field", "email")}>
                            <div className="common-form-field-label">
                                Email
                            </div>
                            <div className="common-form-field-input-container">
                                <input
                                    id="customerEmail"
                                    type="text"
                                    className="common-form-input"
                                    value={props.formEngine.renderableData.email}
                                    onChange={(event) => props.formEngine.handleTextFieldChange("email", event)}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="common-form-body-row options-row">
                        <div className="common-form-options">
                            <PillButton
                                onClick={props.formEngine.onClickSave}
                                containerClasses="common-form-button-container"
                                buttonClasses="common-form-button save-button"
                                buttonText={"SAVE"}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};
